import React from 'react';
import './style.scss';
import cn from 'classnames';

export const AddComponentButton = ({ type, addAction }) => (
  <div data-pdf-node className={cn('workspace-add-button', [type])} onClick={addAction}>
    <div className="workspace-add-button-text">+{type}</div>
  </div>
);
